import { useEffect, useState } from "react";
import {
  loadBrowserSpeechSettings,
  SPEECH_SETTINGS_EVENT,
  type SpeechSettings,
} from "@/features/thread/utils/speech";

/** Subscribe to both this document and other tabs' persisted speech settings. */
export function useThreadSpeechSettings(): SpeechSettings {
  const [settings, setSettings] = useState(loadBrowserSpeechSettings);
  useEffect(() => {
    const reload = (): void => setSettings(loadBrowserSpeechSettings());
    const synchronizeStorage = (event: StorageEvent): void => {
      if (event.key === "bouyomiSettings" || event.key === null) reload();
    };
    addEventListener(SPEECH_SETTINGS_EVENT, reload);
    window.addEventListener("storage", synchronizeStorage);
    // Recheck changes that happened between render and subscription.
    reload();
    return () => {
      removeEventListener(SPEECH_SETTINGS_EVENT, reload);
      window.removeEventListener("storage", synchronizeStorage);
    };
  }, []);
  return settings;
}
